import { getCurrentPosition, pingShiftLocation } from "./shiftService";

const HOURLY_MS = 60 * 60 * 1000;
let intervalId = null;

const pingOnce = async (dispatch) => {
    try {
        const position = await getCurrentPosition();
        pingShiftLocation(dispatch, position.coords.latitude, position.coords.longitude);
    } catch (error) {
        console.warn("Shift geo-ping: could not read location", error?.message);
    }
};

export const startShiftGeoTracking = (dispatch) => {
    if (intervalId) return;
    intervalId = setInterval(() => pingOnce(dispatch), HOURLY_MS);
};

export const stopShiftGeoTracking = () => {
    if (intervalId) {
        clearInterval(intervalId);
        intervalId = null;
    }
};
